const heroKeywords = [
  "吃瓜八卦推理",
  "吃瓜八卦分析",
  "吃瓜八卦细节",
  "吃瓜八卦显微镜",
  "吃瓜八卦蛛丝马迹",
  "吃瓜八卦逻辑链",
];

export default function Hero() {
  return (
    <section className="relative overflow-hidden pt-24 md:pt-28">
      <div className="pointer-events-none absolute -right-24 top-10 hidden h-72 w-72 rounded-full bg-sun-200/40 blur-2xl lg:block" />
      <div className="mx-auto grid max-w-[1360px] items-center gap-8 px-4 py-10 md:px-6 md:py-14 lg:grid-cols-[1.05fr_0.95fr] lg:gap-14">
        <div className="relative z-10 animate-rise">
          <div className="inline-flex items-center gap-2 rounded-full border border-sign-300 bg-sign-100/70 px-3 py-1.5 text-xs font-semibold text-sign-700">
            <i className="ri-flashlight-line" />
            吃瓜也要讲证据 · 第 012 期
          </div>
          <h1 className="mt-5 font-heading text-4xl font-black leading-[1.15] text-ink-950 md:text-5xl lg:text-[56px]">
            把每一颗瓜
            <span className="text-sign-600"> 放大、拆开、排好队 </span>
            再下结论
          </h1>
          <p className="mt-5 max-w-xl text-base leading-8 text-ink-600 md:text-lg">
            这里聚集着吃瓜八卦推理与分析的爱好者：从吃瓜八卦细节到吃瓜八卦显微镜，再循着
            <span className="font-semibold text-ink-800">蛛丝马迹</span>
            理出
            <span className="font-semibold text-ink-800">逻辑链</span>。
            我们用理性视角层层拆解事件线索，发现表面之下的隐藏信息——吃瓜，也能吃出门道。
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#topic"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById("topic")?.scrollIntoView({ behavior: "smooth" });
              }}
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-sign-500 px-6 py-3 text-sm font-semibold text-paper-50 transition-colors hover:bg-sign-600"
            >
              看今日深扒专题
              <i className="ri-arrow-right-line" />
            </a>
            <a
              href="#class"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById("class")?.scrollIntoView({ behavior: "smooth" });
              }}
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-ink-800/20 px-6 py-3 text-sm font-semibold text-ink-700 transition-colors hover:border-sign-400 hover:text-sign-700"
            >
              学一套推理工法
            </a>
          </div>

          <div className="mt-9 flex flex-wrap items-center gap-x-7 gap-y-3">
            {[
              { num: "1200+", label: "深度拆解档案" },
              { num: "3.2w", label: "同频瓜友" },
              { num: "96%", label: "证据可溯源率" },
            ].map((s) => (
              <div key={s.label} className="flex items-center gap-2.5">
                <span className="font-display text-2xl font-bold text-ink-950 md:text-[28px]">{s.num}</span>
                <span className="text-xs text-ink-500">{s.label}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="relative animate-rise" style={{ animationDelay: "120ms" }}>
          <div className="relative overflow-hidden rounded-2xl border border-ink-800/10">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20editorial%20photo%20of%20a%20person%20studying%20a%20large%20photograph%20print%20with%20a%20magnifying%20glass%20at%20a%20cream%20paper%20desk%2C%20printed%20clippings%20and%20red%20string%20evidence%20board%20nearby%2C%20soft%20natural%20window%20light%2C%20cinnabar%20and%20cream%20color%20palette%2C%20documentary%20curiosity%20photography&width=900&height=760&seq=gua-hero-main&orientation=portrait"
              alt="瓜友用放大镜研究打印照片与证据板"
              className="h-[380px] w-full object-cover object-top md:h-[460px]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-ink-950/40 via-transparent to-transparent" />
            <div className="absolute left-4 top-4 flex items-center gap-2 rounded-md bg-paper-50/90 px-3 py-1.5 text-xs font-semibold text-sign-700 backdrop-blur">
              <span className="h-1.5 w-1.5 rounded-full bg-sign-500 animate-pop" />
              今日热搜 · 时间线还原
            </div>
          </div>

          <div className="absolute -bottom-5 -left-3 rounded-xl border border-ink-800/10 bg-paper-50 px-4 py-3 shadow-sheet md:-left-6">
            <div className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-melon-500 text-paper-50">
                <i className="ri-check-double-line" />
              </span>
              <div>
                <p className="text-sm font-bold text-ink-900">证据闭环已完成</p>
                <p className="text-xs text-ink-500">时间戳 · 画面 · 官方记录</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-6 border-y border-ink-800/10 bg-paper-100/70 py-3">
        <div className="flex overflow-hidden whitespace-nowrap">
          <div className="flex animate-marquee items-center gap-10 pr-10">
            {[...heroKeywords, ...heroKeywords].map((k, i) => (
              <span key={i} className="flex items-center gap-10 text-sm font-medium tracking-wide text-ink-500">
                <i className="ri-bubble-chart-line text-sign-500" />
                {k}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}